import { getTypographyTokenValue } from '..'

jest.mock('../index.ts')

const mockedFunction = jest.mocked(getTypographyTokenValue)

describe('getTypographyTokenValue', () => {
  it('should return the right properties for a specific token', async () => {
    expect(mockedFunction('typography-heading-medium')).toEqual('font-family: inter; font-weight: 700; font-size: 1.5rem; line-height: 1.75rem; letter-spacing: -0.038rem;')
  })
})
